import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Col from 'component/utils/Col'
import Mask from 'vanilla-masker'
import RuptureModal from 'component/report/rupture/RuptureModal'
import { RUPTURE_TYPE } from 'constants/config'

class OlderRupture extends Component {
  constructor(props) {
    super(props)

    const { translate } = props

    this.state = {
      toogleModal: false,
      icon: '',
      titleText: '',
      value: 0,
      valueComplement: '',
      subtitle: '',
      titleList: '',
      listSections: [],
      typeContent: 0,
      currency: translate('option.currency'),
      sizeCurrency: translate('size.currency'),
      formatCurrency: {
        separator: translate('separator.currency'),
        delimiter: translate('delimiter.currency'),
      },
    }

    this.handleModal = this.handleModal.bind(this)
    this.renderModal = this.renderModal.bind(this)
    this.toogleModal = this.toogleModal.bind(this)
  }

  toogleModal() {
    this.setState({ toogleModal: !this.state.toogleModal })
  }

  handleModal(typeRupture) {
    const { translate, rupture } = this.props

    const { toogleModal } = this.state

    if (toogleModal) {
      this.setState({ toogleModal: false })
    }

    let state = {
      valueComplement: '',
      toogleModal: true,
    }

    switch (typeRupture) {
      case RUPTURE_TYPE.TOTAL:
        state = {
          ...state,
          icon: 'rupture',
          titleText: translate('ruptures.ruptureTitle'),
          value: `${rupture.total}`,
          subtitle: translate('ruptures.ruptureText'),
          titleList: translate('ruptures.lmsPerTop'),
          listSections: rupture.listLMPerTop,
          typeContent: RUPTURE_TYPE.TOTAL,
        }
        break
      case RUPTURE_TYPE.TOP2500:
        state = {
          ...state,
          icon: 'heart',
          titleText: translate('ruptures.heartTitle'),
          value: `${rupture.topThousand}`,
          subtitle: translate('ruptures.heartText'),
          titleList: translate('ruptures.lms2500PerSection'),
          listSections: rupture.listLMPerSectionTopThousand,
          typeContent: RUPTURE_TYPE.TOP2500,
        }
        break
      case RUPTURE_TYPE.LMS:
        state = {
          ...state,
          icon: 'section',
          titleText: translate('ruptures.sectionTitle'),
          value: rupture.sections,
          subtitle: translate('ruptures.sectionText'),
          titleList: translate('ruptures.perSection'),
          listSections: rupture.listLMPerSection,
          typeContent: RUPTURE_TYPE.LMS,
        }
        break
      case RUPTURE_TYPE.SALES:
        state = {
          ...state,
          icon: 'dollar',
          titleText: translate('ruptures.lossSaleTitle'),
          value:
            this.state.currency +
            Mask.toMoney(
              rupture.lossOfSales.toFixed(this.state.sizeCurrency),
              this.state.formatCurrency
            ),
          subtitle: translate('ruptures.lossSaleText'),
          titleList: translate('ruptures.estimateSection'),
          listSections: rupture.listRupturePerSection,
          typeContent: RUPTURE_TYPE.SALES,
        }
        break
      default:
        break
    }

    this.setState(state)
  }

  renderModal() {
    const { translate } = this.props

    const {
      toogleModal,
      icon,
      titleText,
      value,
      valueComplement,
      subtitle,
      titleList,
      listSections,
      typeContent,
    } = this.state

    if (!toogleModal) {
      return
    }

    const props = {
      translate,
      closeModal: this.toogleModal,
      icon,
      titleText,
      value,
      valueComplement,
      subtitle,
      titleList,
      listSections,
      typeContent,
    }

    return <RuptureModal {...props} />
  }

  render() {
    const { translate, rupture, getCsv, filters } = this.props

    return (
      <div className='ruptures-page container-mobile'>
        <div className='margin-left-double margin-right-double'>
          <Col xs={12} className='margin-bottom-double padding-bottom-double'>
            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='rupture' />
                </div>

                <div
                  className='circular wrap-click'
                  onClick={() => this.handleModal(RUPTURE_TYPE.TOTAL)}
                >
                  <i className='plus' />
                </div>

                <h4 className='heading-4 uppercase title'>
                  {translate('ruptures.ruptureTitle')}
                </h4>
                <div>
                  <span className='highlighted-number'>{rupture.total}</span>
                  <br />
                  <span className='subtext'>{`${filters.dtStart} - ${filters.dtEnd}`}</span>
                </div>
                <p className='text'>{translate('ruptures.ruptureText')}</p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='heart' />
                </div>

                <div
                  className='circular wrap-click'
                  onClick={() => this.handleModal(RUPTURE_TYPE.TOP2500)}
                >
                  <i className='plus' />
                </div>

                <h4 className='heading-4 uppercase title'>
                  {translate('ruptures.heartTitle')}
                </h4>
                <div>
                  <span className='highlighted-number'>
                    {rupture.topThousand}
                  </span>
                  <br />
                  <span className='subtext'>{`${filters.dtStart} - ${filters.dtEnd}`}</span>
                </div>
                <p className='text'>{translate('ruptures.heartText')}</p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='section' />
                </div>

                <div
                  className='circular wrap-click'
                  onClick={() => this.handleModal(RUPTURE_TYPE.LMS)}
                >
                  <i className='plus' />
                </div>

                <h4 className='heading-4 uppercase title'>
                  {translate('ruptures.sectionTitle')}
                </h4>
                <div>
                  <span className='highlighted-number'>{rupture.sections}</span>
                  <br />
                  <span className='subtext'>{`${filters.dtStart} - ${filters.dtEnd}`}</span>
                </div>
                <p className='text'>{translate('ruptures.sectionText')}</p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={3}>
              <div className='rectangle border rounded'>
                <div className='circular wrap'>
                  <i className='dollar' />
                </div>

                <div
                  className='circular wrap-click'
                  onClick={() => this.handleModal(RUPTURE_TYPE.SALES)}
                >
                  <i className='plus' />
                </div>

                <h4 className='heading-4 uppercase title'>
                  {translate('ruptures.lossSaleTitle')}
                </h4>
                <div>
                  <span className='highlighted-number'>
                    {this.state.currency}{' '}
                    {Mask.toMoney(
                      rupture.lossOfSales
                        ? rupture.lossOfSales.toFixed(this.state.sizeCurrency)
                        : 0,
                      this.state.formatCurrency
                    )}
                  </span>
                  <br />
                  <span className='subtext'>{`${filters.dtStart} - ${filters.dtEnd}`}</span>
                </div>
                <p className='text'>{translate('ruptures.lossSaleText')}</p>
              </div>
            </Col>

            {/* <Col xs={12} sm={6} md={3}>
             <div className='rectangle border rounded'>
             <div className='circular wrap'>
             <i className='calendar' />
             </div>
             <h4 className='heading-4 uppercase title'>{translate('ruptures.calendarTitle')}</h4>
             <div>
             <span className='highlighted-number'>{rupture.delayedDeliveryDays}</span>
             <br />
             <span className='subtext'>{translate('ruptures.calendarSubText')}</span>
             </div>
             <p className='text'>{translate('ruptures.calendarText')}</p>
             </div>
             </Col> */}
          </Col>
        </div>

        {/* <Row className='margin-top-double margin-bottom'>
         <Col xs={12} md={6} />
         </Row> */}

        {/* <Row className='margin-top-double margin-bottom'> */}
        <Col xs={6} md={4} mdOffset={4}>
          <button
            type='button'
            onClick={getCsv}
            className='button button-primary button-full'
          >
            {translate('ruptures.excelReport')}
          </button>
        </Col>

        {/* <Col xs={6} md={3}>
         <button
         type='button'
         onClick={getPdf}
         className='button button-primary button-full'
         >
         {translate('ruptures.pdfReport')}
         </button>
         </Col>
         </Row> */}

        {this.renderModal()}
      </div>
    )
  }
}

OlderRupture.propTypes = {
  translate: PropTypes.func.isRequired,
  rupture: PropTypes.object.isRequired,
  getCsv: PropTypes.func.isRequired,
  getPdf: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
}

export default OlderRupture
